import { Component } from '@angular/core';
import { BuilderService } from './feature/builder/services/builder.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  constructor(private builderService: BuilderService) {
    //  debugger
    this.builderService.mapDatapoints();
    this.builderService.getRewardsList();
  }
}
